/* eslint-disable no-mixed-operators */
/* eslint react/jsx-pascal-case: 0 */
import * as React from 'react';
import { MarqueeSelection, SelectionMode, Selection } from '@fluentui/react/lib/MarqueeSelection';
import { DetailsList, DetailsListLayoutMode, IColumn } from '@fluentui/react/lib/DetailsList';
import Helper from '../../../core/libraries/Helper';
import DataValidation from '../../../core/libraries/DataValidation';
import Constants from '../../../core/libraries/Constants';
import { connect } from 'react-redux';
import _ from 'lodash';
import RbLabel, { LabelSize } from '../../../bosch-react/components/label/RbLabel';
import { IUserProfile } from '../../Auth/types';
import { confirmDialog, showDialog } from '../../Dialog/actions';
import { RootState } from '../../../store/store';
import { withRouter } from 'react-router-dom';
import { ILowerFirstCaseMetadata } from '../../AccessMediator/types';
import { getReport } from '../../AccessMediator/services';
import MoveReport_MoveInformation from './MoveReport_MoveInformation';
import MoveReport_AdditionalInformation from './MoveReport_AdditionalInformation';
import { moveSingleReport } from './services';
import { LoadingBasicDialog } from '../../../core/components/LoadingDialog';
import Template from '../../../core/libraries/Template';

interface MoveReportProps {
    userProfile: IUserProfile | undefined,
    confirmDialog: typeof confirmDialog,
    showDialog: typeof showDialog,
    match: any
}

interface IMoveReportState {
    srcItem: ILowerFirstCaseMetadata | null,
    moveItem: ILowerFirstCaseMetadata | null,
    isLoading: boolean,
    reportId: string,
    isValidDepartment: boolean,
}

class MoveReport extends React.Component<MoveReportProps, IMoveReportState> {

    moveInfoRef: React.RefObject<any> = React.createRef();

    additionalInfoRef: React.RefObject<any> = React.createRef();

    constructor(props: MoveReportProps) {
        super(props);

        this.state = {
            moveItem: null,
            srcItem: null,
            isLoading: true,
            reportId: "",
            isValidDepartment: false
        };
        this.renderGeneralInformation = this.renderGeneralInformation.bind(this);
        this.renderMoveInformation = this.renderMoveInformation.bind(this);
        this.renderAdditionalInformation = this.renderAdditionalInformation.bind(this);

        this.updateMoveItem = this.updateMoveItem.bind(this);
        this.updateIsValidDepartment = this.updateIsValidDepartment.bind(this);


        this.validateAdditionalInformation = this.validateAdditionalInformation.bind(this);
        this.move = this.move.bind(this);
        this.closeDialogWithMessage = this.closeDialogWithMessage.bind(this);
    }

    async componentDidMount() {
        let parameters: any = this.props.match.params;
        let id = parameters["id"];

        this.setState({
            reportId: id
        })
        if (!!this.props.userProfile) {
            if (!!this.props.userProfile?.permissions?.isAdmin) {
                if (id !== "") {
                    let report = await getReport(id);
                    if (!!report.data) {
                        this.setState({
                            srcItem: report.data,
                            moveItem: report.data,
                            isLoading: false
                        }, () => {
                            !Helper.checkHasPermissionOnDocument(this.state.srcItem, this.props.userProfile) && this.closeDialogWithMessage(Constants.CONFIRMATION_MESSAGE.NO_PERMISSION.CONTENT);
                        });
                    }
                    else {
                        this.setState({
                            isLoading: false
                        });
                    }
                }
                else {
                    this.closeDialogWithMessage(Constants.CONFIRMATION_MESSAGE.MOVE_REPORT.WRONG_LINK);
                }
            }
            else {
                this.closeDialogWithMessage(Constants.CONFIRMATION_MESSAGE.NO_PERMISSION.CONTENT);
            }
        }
    }

    async componentDidUpdate(prevProps: Readonly<MoveReportProps>, prevState: Readonly<IMoveReportState>, snapshot?: any) {
        if (prevProps.userProfile !== this.props.userProfile) {
            let report = !!this.props.userProfile && await getReport(this.state.reportId)
            if (!!report.data) {
                this.setState({
                    srcItem: report.data,
                    moveItem: report.data,
                }, () => {
                    !Helper.checkHasPermissionOnDocument(this.state.srcItem, this.props.userProfile) && this.closeDialogWithMessage(Constants.CONFIRMATION_MESSAGE.NO_PERMISSION.CONTENT);
                });
            }
            this.setState({
                isLoading: false,
            });
        }
    }

    render() {
        return (
            !this.state.isLoading && <div className="ms-Grid">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm1" />
                    <div className="ms-Grid-col ms-sm10">

                        <div className="ms-Grid">
                            <div className="ms-Grid-row">
                                <RbLabel className="header-title">Move Report</RbLabel>
                            </div>
                            {this.renderGeneralInformation()}
                            <div className="ms-Grid-row">
                                {(!_.isNil(this.state.srcItem)) ? this.renderMoveInformation() : ""}
                                {(!_.isNil(this.state.srcItem)) ? this.renderAdditionalInformation() : ""}
                            </div>
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12">
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="ms-Grid-col ms-sm1" />
                </div>
            </div> ||
            <LoadingBasicDialog dialogMessage={'Loading...'} />
        );
    }

    renderGeneralInformation() {
        let columns: IColumn[] = [
            {
                key: 'guid', name: 'Guid',
                currentWidth: Helper.resizeColumnByScreenWidth(20),
                minWidth: Helper.resizeColumnByScreenWidth(20), isResizable: true,
                onRender: (item: ILowerFirstCaseMetadata) => {
                    return (<RbLabel size={LabelSize.Small} >{item.guid}</RbLabel>);
                }
            },
            {
                key: 'title', name: 'Title',
                currentWidth: Helper.resizeColumnByScreenWidth(20),
                minWidth: Helper.resizeColumnByScreenWidth(20), isResizable: true,
                onRender: (item: ILowerFirstCaseMetadata) => {
                    return (<RbLabel size={LabelSize.Small} >{item.title}</RbLabel>);
                }
            },
            {
                key: 'uploadType', name: 'Upload Type',
                currentWidth: Helper.resizeColumnByScreenWidth(20),
                minWidth: Helper.resizeColumnByScreenWidth(20), isResizable: true,
                onRender: (item: ILowerFirstCaseMetadata) => {
                    return (<RbLabel size={LabelSize.Small} >{item.uploadType}</RbLabel>);
                }
            },
            {
                key: 'securityClass', name: 'Security Class',
                currentWidth: Helper.resizeColumnByScreenWidth(20),
                minWidth: Helper.resizeColumnByScreenWidth(20), isResizable: true,
                onRender: (item: ILowerFirstCaseMetadata) => {
                    return (<RbLabel size={LabelSize.Small} >{Helper.getSCLongName(item.securityClass ?? "")}</RbLabel>);
                }
            },
            {
                key: 'department', name: 'Department',
                currentWidth: Helper.resizeColumnByScreenWidth(12),
                minWidth: Helper.resizeColumnByScreenWidth(12), isResizable: true,
                onRender: (item: ILowerFirstCaseMetadata) => {
                    return (<RbLabel size={LabelSize.Small} >{item.department}</RbLabel>);
                }
            },
            {
                key: 'authors', name: 'Authors',
                currentWidth: Helper.resizeColumnByScreenWidth(28),
                minWidth: Helper.resizeColumnByScreenWidth(28), isResizable: true,
                onRender: (item: ILowerFirstCaseMetadata) => {
                    return (
                        Template.renderReadOnlyPeople(!!item.authors && item.authors.length > 0 && item.authors || [], item.authorDisplayName || "")
                    );
                }
            },
        ];
        return (
            <div className="ms-Grid-row">
                <MarqueeSelection selection={new Selection()}>
                    <DetailsList
                        compact={true}
                        items={[this.state.srcItem]}
                        columns={columns}
                        setKey="set"
                        selectionMode={SelectionMode.none}
                        layoutMode={DetailsListLayoutMode.fixedColumns}
                        onShouldVirtualize={() => { return false; }}
                    />
                </MarqueeSelection>
            </div>
        );
    }

    renderMoveInformation() {
        if (!_.isNil(this.state.srcItem)) {
            return (
                <div className="ms-Grid-col ms-sm6">
                    <MoveReport_MoveInformation
                        ref={this.moveInfoRef}
                        srcItem={this.state.srcItem}
                        moveItem={this.state.moveItem}
                        updateMoveItem={this.updateMoveItem}
                        move={this.move}
                        updateIsValidDept={this.updateIsValidDepartment} />
                </div>
            );
        }
        return "";
    }

    renderAdditionalInformation() {
        if (!_.isNil(this.state.srcItem)) {
            return (
                <div className="ms-Grid-col ms-sm6">
                    <MoveReport_AdditionalInformation
                        ref={this.additionalInfoRef}
                        srcItem={this.state.srcItem}
                        moveItem={this.state.moveItem}
                        updateMoveItem={this.updateMoveItem} />
                </div>
            );
        }
        return "";
    }

    closeDialogWithMessage(message: string) {
        this.props.confirmDialog(
            Constants.CONFIRMATION_MESSAGE.MOVE_REPORT.TITLE,
            message,
            true,
            () => {
                // Javascript close dialog
                window.close();
                // If close does not work, return to home page
                window.location.href = process.env.REACT_APP_HOME ?? "/";
            }
        );
    }

    updateMoveItem(key: keyof IMoveReportState['moveItem'], value: any) {
        this.setState(prevState => ({
            moveItem: {
                ...prevState.moveItem,
                [key]: value,
            },
        }));
    }

    updateIsValidDepartment(value: boolean) {
        this.setState({
            isValidDepartment: value
        });
    }

    validatePermissionOnDestination() {
        const { moveItem } = this.state
        if (!!moveItem && moveItem.uploadType && moveItem.division)
            return Helper.checkHasPermissionOnDestination(moveItem?.uploadType, moveItem?.division, this.props.userProfile);
        return false;
    }

    async move() {
        if (!!this.validatePermissionOnDestination()) {
            const isValid = this.validateAdditionalInformation(this.additionalInfoRef.current) && this.validateCommonInformation(this.moveInfoRef.current);
            const { srcItem, moveItem } = this.state;
            if (isValid) {
                this.props.showDialog("Moving...")
                let movingReport: ILowerFirstCaseMetadata = {
                    id: srcItem?.id,
                    ...moveItem
                }

                const success = await moveSingleReport(movingReport)
                this.props.showDialog(false);
                !!success
                    && this.props.confirmDialog("Success", "Report has been moved successfully", true, () => { window.location.reload() })
                    || this.props.confirmDialog("Error", "An error occurred while moving the report", true, () => { });
            }
            else this.props.confirmDialog("Validation Error", "Please fill in all required fields", true, () => { });
        }
        else this.props.confirmDialog("No Permission", "You have no permission to take this action", true, () => { });
    }

    validateCommonInformation = (moveInfo: any) => {
        let result = true;
        // Department
        const checkDepartment = DataValidation.textValidation(moveInfo.state.selectedTargetDepartment || "", "department", true);
        moveInfo.setState({ validationMessage: { department: checkDepartment } });
        result = result && checkDepartment === "";
        return result;
    }
    
    validateAdditionalInformation = (additionalInfo: any) => {
        let result = true;
        let fromUploadType = this.state.srcItem?.uploadType;
        let toUploadType = this.state.moveItem?.uploadType;
        let validationObj: any = {};
        switch (fromUploadType) {
            case Constants.UPLOAD_TYPE.RnD:
                {
                    switch (toUploadType) {
                        case Constants.UPLOAD_TYPE.RnD:
                            {
                                // Report contains export controlled material - has default value: false
                                // Security class
                                let checkSC = DataValidation.dropdownValidation(additionalInfo.state.securityClass, "security class", true);
                                validationObj.securityClass = checkSC;
                                result = result && checkSC === "";
                                break;
                            }
                        case Constants.UPLOAD_TYPE.LL:
                            {
                                // Product & Process
                                let checkProduct = DataValidation.textValidation(additionalInfo.state.product, "product", true, null, 250);
                                let checkProcess = DataValidation.textValidation(additionalInfo.state.process, "process", true, null, 250);
                                if (checkProduct !== "" && checkProcess !== "") {
                                    if (checkProcess.indexOf("maximum") === -1) {
                                        validationObj.product = checkProduct;
                                    }
                                    if (checkProduct.indexOf("maximum") === -1) {
                                        validationObj.process = checkProcess;
                                    }
                                    result = false;
                                }
                                // Plant/Business unit
                                let checkPlantBU = DataValidation.textValidation(additionalInfo.state.plantBU, "plant or business unit", true);
                                validationObj.plantBU = checkPlantBU;
                                result = result && checkPlantBU === "";
                                // IQIS number
                                let checkIQISNumber = DataValidation.textValidation(additionalInfo.state.iqisNumber, "IQIS number", false, null, 250);
                                validationObj.iqisNumber = checkIQISNumber;
                                result = result && checkIQISNumber === "";
                                break;
                            }
                        default: {
                            break;
                        }
                    }
                    break;
                }
            case Constants.UPLOAD_TYPE.LL:
                {
                    switch (toUploadType) {
                        case Constants.UPLOAD_TYPE.RnD:
                            {
                                // Abstract
                                let checkAbstract = DataValidation.textValidation(additionalInfo.state.abstract, "abstract", true);
                                validationObj.abstract = checkAbstract;
                                result = result && checkAbstract === "";
                                // Report type
                                let checkDocumentType = DataValidation.dropdownValidation(additionalInfo.state.documentType, "document type", true);
                                validationObj.documentType = checkDocumentType;
                                result = result && checkDocumentType === "";
                                // Report contains export controlled material - has default value: false
                                // Security class
                                let checkSC = DataValidation.dropdownValidation(additionalInfo.state.securityClass, "security class", true);
                                validationObj.securityClass = checkSC;
                                result = result && checkSC === "";
                                // Report number
                                let checkDocumentNumber = DataValidation.textValidation(additionalInfo.state.documentNumber, "report number", false, null, 250);
                                validationObj.documentNumber = checkDocumentNumber;
                                result = result && checkDocumentNumber === "";
                                // Project number
                                let checkProjectNumber = DataValidation.textValidation(additionalInfo.state.projectNumber, "project number", false, null, 250);
                                validationObj.projectNumber = checkProjectNumber;
                                result = result && checkProjectNumber === "";
                                break;
                            }
                        case Constants.UPLOAD_TYPE.LL:
                            {
                                // No additional information
                                break;
                            }
                        default: {
                            break;
                        }
                    }
                    break;
                }
        }
        additionalInfo.setState({ validationMessage: validationObj });
        return result;
    }
}

const mapStateToProps = (state: RootState) => ({
    userProfile: state.auth.userProfile
});

export default withRouter(connect(mapStateToProps, { confirmDialog, showDialog })(MoveReport));